import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ValidationReasonDialogData } from '../../../domain/data/validation-reason-dialog-data';

@Component({
    templateUrl: './validation-reason.dialog.html',
    styleUrls: ['./validation-reason.dialog.scss'],
})
export class ValidationReasonDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ValidationReasonDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ValidationReasonDialogData
    ) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        this.dialogRef.close(false);
    }

    onSubmit() {
        this.dialogRef.close(true);
    }
}
